
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnPauseAudio extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 80.5, y ?? 80.5);

    // btn_endscreen_png
    const btn_endscreen_png = scene.add.image(0, 0, "endscreen", "popup-btn-left.png");
    this.add(btn_endscreen_png);

    // icon_popuppause_sound_off_png
    const icon_popuppause_sound_off_png = scene.add.image(-2, -8, "endscreen", "popup-icon-sound-off.png");
    icon_popuppause_sound_off_png.visible = false;
    this.add(icon_popuppause_sound_off_png);

    // icon_popuppause_sound_on_png
    const icon_popuppause_sound_on_png = scene.add.image(-2, -8, "endscreen", "popup-icon-sound-on.png");
    this.add(icon_popuppause_sound_on_png);

    // lists
    const onList = [icon_popuppause_sound_on_png];
    const offList = [icon_popuppause_sound_off_png];

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.onList = onList;
    thisUIButton.offList = offList;

    this.btn_endscreen_png = btn_endscreen_png;
    this.icon_popuppause_sound_off_png = icon_popuppause_sound_off_png;
    this.icon_popuppause_sound_on_png = icon_popuppause_sound_on_png;
    this.onList = onList;
    this.offList = offList;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private btn_endscreen_png: Phaser.GameObjects.Image;
  private icon_popuppause_sound_off_png: Phaser.GameObjects.Image;
  private icon_popuppause_sound_on_png: Phaser.GameObjects.Image;
  private onList: Phaser.GameObjects.Image[];
  private offList: Phaser.GameObjects.Image[];

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
